const getConfigName = state => state.configName;

export default {
  getConfigName
};
